<template>
    <div id="left-navbar-component">
        <div v-if="$auth.user()">
            <v-app-bar
                v-if="is_mobile && $store.getters['manage_navbar/show_left_navbar']"
                app
                class="app-bar"
                color="white"
                data-cy="mobile-appbar"
                height="90"
            >
                <v-layout class="justify-start">
                    <v-icon class="my-auto round-hitbox-icon" data-cy="menu-burger" @click="drawer = !drawer">mdi-menu </v-icon>

                    <v-btn
                        v-if="$store.getters['notifications/total_notifications_not_see'] > 0"
                        class="unsolicited-btn notification-pin-menu-leftnavbar"
                        color="error"
                        elevation="0"
                        fab
                    />

                    <img :src="$store.getters['display_option/logo']" alt="img_logo" class="mx-2" height="40px" />
                </v-layout>

                <v-layout class="justify-end">
                    <div class="nav-grid">
                        <div>
                            <v-icon
                                v-if="$store.getters['user_connected/user_connected'].id_professional === 14"
                                class="font-color-normal pointer d-block"
                                size="30"
                                @click="$refs.DialogContactComponent.dialog_contact = true"
                            >
                                mdi-lifebuoy
                            </v-icon>
                        </div>
                        <div class="size-30" @click="navigateTo('notifications')">
                            <v-badge
                                :content="$store.getters['notifications/total_notifications_not_see']"
                                :value="$store.getters['notifications/total_notifications_not_see']"
                                class="badge-lower-size"
                                color="error"
                                overlap
                            >
                                <v-icon class="mx-auto font-color-normal" size="30" @click="navigateTo('notifications')"> mdi-bell </v-icon>
                            </v-badge>
                        </div>
                        <div class="pointer" @click="$refs.profileDialog.dialog_profile = true">
                            <ProfilePictureComponent
                                :user="this.$store.getters['user_connected/user_connected']"
                                :verify_certified="true"
                                :width="34"
                            />
                        </div>

                        <span>
                            <span
                                v-if="$store.getters['user_connected/user_connected'].id_professional === 14"
                                class="font-10 pointer"
                                @click="$refs.DialogContactComponent.dialog_contact = true"
                            >
                                {{ $t('left_navbar_component.assistance') }}
                            </span>
                        </span>

                        <span class="font-10 pointer" @click="navigateTo('notifications')">
                            {{ $t('left_navbar_component.notifications') }}
                        </span>

                        <span class="font-10 pointer" @click="$refs.profileDialog.dialog_profile = true">
                            {{ $t('left_navbar_component.profile') }}
                        </span>
                    </div>
                </v-layout>
            </v-app-bar>

            <v-navigation-drawer v-model="drawer" :temporary="is_mobile" app color="white" data-cy="left-navbar" mobile-breakpoint="">
                <div class="pt-12 pl-4 d-flex justify-start">
                    <img :src="$store.getters['display_option/logo']" alt="Logo" class="mr-2" style="max-width: 50%; max-height: 64px" />
                    <span class="secondary--text font-14 my-auto mr-2 line-height-16">
                        {{ $store.getters['user_connected/user_connected'].client_name }}
                    </span>
                </div>

                <v-list>
                    <v-list-item-group color="primary">
                        <v-divider class="ml-3 mr-5" color="white" />
                        <v-progress-linear v-if="$store.state.manage_navbar.loading" indeterminate />

                        <v-list-item
                            v-if="$store.getters['asset_module/has_suiclean'] && $store.getters['asset_module/first_suiclean_id_domicile']"
                            :to="{ name: 'consumption_tracking', params: { id: $store.getters['asset_module/first_suiclean_id_domicile'] } }"
                            class="py-1"
                            link
                        >
                            <v-list-item-icon class="mr-6 ml-2">
                                <v-icon>mdi-chart-line</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <span>{{ $t('left_navbar_component.consumption_tracking') }}</span>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <template v-for="configuration in $store.getters['user_navbar_configuration/navbar_configurations']">
                            <v-list-item
                                v-if="
                                    configuration.displayed &&
                                    (configuration.page_link === 'sites'
                                        ? $store.getters['asset_module/has_suiclean']
                                        : configuration.designation === 'TNK' || userHasAccess(configuration.designation, role_no_access))
                                "
                                :key="configuration.page_link"
                                :data-cy="'navbar-item-' + configuration.page_link"
                                :to="{ path: '/' + configuration.page_link }"
                                class="py-1"
                                link
                            >
                                <v-list-item-icon class="mr-6 ml-2">
                                    <v-icon>{{ configuration.icon }}</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        <v-badge
                                            :content="calculateNbNotificationsByModule(configuration.page_link)"
                                            :value="calculateNbNotificationsByModule(configuration.page_link)"
                                            class="badge-lower-size my-auto"
                                            color="error"
                                            inline
                                        >
                                            <span v-if="configuration.page_link === 'equipment'">
                                                {{ $t('left_navbar_component.assets') }}
                                            </span>
                                            <span v-else>
                                                {{ $t('configuration_navbar.' + configuration.page_name) }}
                                            </span>
                                        </v-badge>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>

                        <template v-if="!is_devices_paid_by_pro">
                            <v-divider class="ml-3 mr-5" color="white" />
                            <v-list-item :to="{ path: '/subscription' }" class="py-1" link>
                                <v-list-item-icon class="mr-6 ml-2">
                                    <v-icon>mdi-cash-sync</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span>{{ $t('left_navbar_component.subscription') }}</span>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>

                        <v-divider class="mb-2 ml-3 mr-5" color="white" />

                        <v-list-item :data-cy="'navbar-item-parameter'" :to="{ path: '/parameter' }" class="py-1" link>
                            <v-list-item-icon class="mr-6 ml-2">
                                <v-icon>mdi-cog</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <span>{{ $t('left_navbar_component.parameters') }}</span>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-divider class="mb-2 ml-3 mr-5" color="white" />
                    </v-list-item-group>
                </v-list>
            </v-navigation-drawer>
        </div>

        <ProfileDialogComponent ref="profileDialog" />

        <DialogContactComponent ref="DialogContactComponent" />
    </div>
</template>

<script>
import ProfileDialogComponent from '@/components/profile/vision/ProfileDialogComponent.vue'
import DialogContactComponent from '@/components/global/DialogContactComponent.vue'
import ProfilePictureComponent from '@/components/profile/containment/ProfilePictureComponent.vue'

export default {
    name: 'NavbarLeftComponent',
    components: {
        ProfilePictureComponent,
        ProfileDialogComponent,
        DialogContactComponent,
    },
    computed: {
        is_devices_paid_by_pro: {
            get() {
                return (
                    this.$store.getters['tanks/getDevicesContractPaidByPro'] ||
                    this.$store.getters['asset_module/getDevicesContractPaidByPro']
                )
            },
        },
    },
    methods: {
        redirection(route) {
            if (route === this.$router.currentRoute.name && this.is_mobile) {
                this.drawer = false
            }
            this.navigateTo(route)
        },
    },
}
</script>

<style>
.logo-left-navbar .v-image__image {
    background-position: left !important;
}

.notification-pin-menu-leftnavbar {
    height: 7px !important;
    width: 7px !important;
    position: absolute !important;
    top: 35px;
    left: 33px;
}

.app-bar {
    box-shadow: 0 4px 26px #3c3c4449 !important;
}

.round-hitbox-icon {
    height: 27px;
}
</style>
